import { useState,useEffect } from "react";
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';
import axios from "axios";
import bcrypt from 'bcryptjs';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import { useNavigate } from "react-router-dom";
import { GlobalLoading, showLoading } from 'react-global-loading';
import {API_URL}  from '../Constant';
import {jwtDecode} from "jwt-decode";
import platform from "platform";


const Login = ({loginCallToParent}) => {


 const tosterStyle= {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
      };

  const [userId, setUserId] = useState("");
  const [pwd, setPassword] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

// ================= PLATFORM INFO =================
const getPlatformInfo = async () => {
  let ipAddress = "";

  try {
    const res = await axios.get("https://api.ipify.org?format=json", { timeout: 5000 });
    ipAddress = res.data.ip || "";
  } catch {
    ipAddress = "";
  }

  return {
    browser: platform.name || "",
    browserVersion: platform.version || "",
    os: platform.os?.family || "",
    osVersion: platform.os?.version || "",
    device: platform.product || "Desktop",
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    userAgent: platform.ua || "",
    ipAddress: ipAddress
  };
};

  async function submitButtonClick(e){
    
    e.preventDefault();
    const salt = bcrypt.genSaltSync(10)
    const password = bcrypt.hashSync(pwd, salt)
    if (!isNameValid || !isPasswordsValid) {
     toast.error('User Id and Password are required',tosterStyle);
      return;
    } 
   
    // Captcha check
    if (!captcha || captcha.trim().length === 0) {
      toast.error('Captcha is required', tosterStyle);
      setCaptcha('');
      loadCaptchaEnginge(6,'#555555','white');
      return;
    }
    if (validateCaptcha(captcha) === false) {
      toast.error('Captcha does not match', tosterStyle);
      setCaptcha('');
      loadCaptchaEnginge(6,'#555555','white');
      return;
    }
    
    showLoading(true);
    const platform_info = await getPlatformInfo();
    try {
       
      const response = await axios.post(`${API_URL}api/auth/signin`, {
        salt: salt,
        user_id: userId,
        password: password,
        platform_info: platform_info
      })
   
        const accessToken = response?.data?.data?.token;
        if(response?.data?.status && accessToken){
          const decodeToken=jwtDecode(accessToken);
          const statusFlag=decodeToken.id.STATUS_FLAG;
          showLoading(false);
          loginCallToParent(accessToken);
    
         if(statusFlag==='U'){
           navigate("/changePwd");
         }else{
          navigate("/dashboard");
         }
        
      }else{
          showLoading(false);
          toast.error(response?.data?.message || 'Login Error',tosterStyle);
          loadCaptchaEnginge(6,'#555555','white');
          setCaptcha('');
        }
          
   } catch (error) {
      showLoading(false);
      toast.error(
        error?.response?.data?.message || 'Unable to connect to server. Please try again.',
        tosterStyle
      );
      loadCaptchaEnginge(6,'#555555','white');
      setCaptcha('');
      console.error("Error logging in:", error);
      
      
    }
}

 useEffect(() => {
      loadCaptchaEnginge(6,'#555555','white');
    },[]);

  const refreshCaptcha= ()=>{
      document.getElementById("reload_href").click();
    }

 const restForm=(e)=>{
     e.preventDefault();
      setUserId("");
      setPassword("");
      setCaptcha("");
     
    }

 
  const isNameValid = userId.trim().length > 0; 
  const isPasswordsValid = pwd.trim().length > 0;
 
  return (
    <>
    <div className="loginbg d-flex justify-content-center align-items-center">
       <GlobalLoading />
       <ToastContainer />
       
    <form>
      <div className="login_box">
        <div className="row">
          <div className="col-12 text-center">
            <p className="mb-0"><a href="index.html"><img src="assets/images/logo.png" className="logo" alt="UPDES"/></a></p>
            <h5 className="mb-0 updesloin-text">Directorate of Economics and Statistics</h5>
            <h5 className="updesloin-subtext my-0 p-0 ">Government of Uttar Pradesh</h5>
            <h6 className="updesloin-subtext2">Statistical Information System</h6>
          </div>
           <div className="text-center">
            <h3 className="text-uppercase signin-title">Sign in</h3>
          </div>
          <div className="col-12 mb-4">
            <label>User ID</label>
            <input type="text" className="form-control" value={userId} onChange={(e) => {
              let value = e.target.value;
              // Remove leading and trailing spaces
              value = value.replace(/^\s+|\s+$/g, '');
              setUserId(value);
            }}  placeholder="Enter your user id"/>
          </div>
          
          <div className="col-12 mb-4">
            <label>Password</label>
            <div className="position-relative">
            <input type={showPassword ? "text" : "password"} className="form-control" value={pwd} onChange={(e) => {
              let value = e.target.value;
              // Remove leading and trailing spaces
              value = value.replace(/^\s+|\s+$/g, '');
              setPassword(value);
            }} placeholder="Enter your password"/>
              <a href="#!" className="eye_password" onClick={togglePasswordVisibility}>
              {showPassword ? (
                 <i className="fa fa-eye"></i>
                 ) : (
                  <i className="fa fa-eye-slash"></i>
                )}
                
               </a>
            </div>
           </div>
  
     </div>
        
        <div className="row align-items-center mb-4">
          <div className="col-5">
            <input type="text" className="form-control" value={captcha} onChange={(e)=>setCaptcha(e.target.value)} placeholder="Enter captcha"/>
          </div>
         
           <div className="col-5 px-0">
            <LoadCanvasTemplate reloadText="Reload"  />
           </div>
          
          <div className="col-2 font14 text-center ps-0"><a  onClick={refreshCaptcha} href="#!">
            <img width="27" height="27" src="assets/images/refresh.svg" alt=""/></a>
          </div>
          
          <div className="col-12 d-none">
            <small className="text-danger">Captcha mismatch. try again!</small>
          </div>
          
        </div>
        
        <div className="row align-items-center">
          <div className="col-6">
            <button type="submit" onClick={submitButtonClick} className="btn w-100 btn_orange" >Log
              in</button>
          </div>
          
          <div className="col-6 font14 text-end">
            <button onClick={restForm} type="reset" className="btn w-100 btn_gray">Reset</button>
         </div>
          
          {/* <div className="col-12 text-center mt-4">
            <a target="_blank" href="https://onedrive.live.com/?authkey=%21AHjy6gkX5uBpa%2Dk&id=B6754D9BC49DF11F%211345&cid=B6754D9BC49DF11F" className="login-download-link" rel="noreferrer">Download OffLine Version <img className="d-inline-block ms-1" src="assets/images/download.svg" alt=""/></a>
          </div> */}
        </div>
        
      </div>
      <div className="col-12 text-center copyright-text">
           Copyright © {currentYear}&nbsp;UPDES.  All Rights Reserved.
    </div>
      
    </form>
   </div>

</>
  );
};

export default Login;
